import React from 'react';
import { StatusProps } from 'types/Dataset';
import { NTooltip } from '@innersource-nn/novoui-react';

const CardIcon = ({ status, color, icon, tooltip }: StatusProps) => {
    return (
        <div
            className={`bg-${color}-light w-24 h-24 rounded-4 flex items-center justify-center border-${color}-light border-1 hover:border-true-blue`}
        >
            {tooltip ? (
                <NTooltip
                    content={tooltip}
                    key={`${status}-tooltip`}
                    placement="left"
                    className="z-100"
                >
                    {icon}
                </NTooltip>
            ) : (
                icon
            )}
        </div>
    );
};

export default CardIcon;
